import { motion, useReducedMotion } from "framer-motion";
import { CONTROL } from "../../constants/testIds";
import { formatCurrency } from "../../lib/format";
import { fadeUp } from "../../lib/motion";

// UX-CP-01 §1 "Revenue breakdown panel: subscription vs take-rate vs ad-share". DEFECT-D-09:
// subscription MRR is now real (billing_amount/billing_cycle captured at provisioning/edit,
// normalized to a monthly figure) — no longer flagged as "not modeled". ad_share is money the
// platform DISTRIBUTES TO gyms (not platform income) — labeled distinctly, not summed into a
// misleading single "platform revenue" total.
export function RevenueBreakdownPanel({ revenue, dashboardRevenue, loading }) {
  const reducedMotion = useReducedMotion();
  if (loading || !revenue) {
    return <div className="solid-surface rounded-[14px] p-5 h-40 animate-pulse" data-testid={CONTROL.revenuePanel} />;
  }
  return (
    <motion.div {...fadeUp(reducedMotion)} className="solid-surface rounded-[14px] p-5" data-testid={CONTROL.revenuePanel}>
      <p className="eyebrow mb-3">Revenue breakdown</p>
      <div className="space-y-3">
        {dashboardRevenue?.available !== false && (
          <Row
            label="Subscription MRR" value={formatCurrency(dashboardRevenue?.mrr ?? 0)}
            note={dashboardRevenue?.mrr_growth_percent != null ? `${dashboardRevenue.mrr_growth_percent >= 0 ? "+" : ""}${dashboardRevenue.mrr_growth_percent}% vs ~30 days ago` : (dashboardRevenue?.mrr_growth_note || "Real — from subscription.billing_amount, normalized to monthly")}
          />
        )}
        <Row label="Take-rate revenue" value={formatCurrency(revenue.take_rate.amount)} note="Real — from ledger_entry.type=take_rate" />
        <Row
          label="Ad-share distributed to gyms"
          value={formatCurrency(revenue.ad_share.amount)}
          note="Payout to gyms, not platform income — see tooltip"
          tooltip={revenue.ad_share.note}
        />
      </div>
    </motion.div>
  );
}

function Row({ label, value, note, tooltip, muted }) {
  return (
    <div className="flex items-center justify-between gap-4" title={tooltip}>
      <div>
        <p className="text-sm font-medium" style={{ color: "var(--scarlet-text)" }}>{label}</p>
        <p className="text-xs" style={{ color: "var(--scarlet-text-secondary)" }}>{note}</p>
      </div>
      <p className="text-lg font-bold tabular-nums-force shrink-0" style={{ color: muted ? "var(--scarlet-text-secondary)" : "var(--scarlet-text)" }}>{value}</p>
    </div>
  );
}
